'use client';

import { c as _c } from "react/compiler-runtime";
import { IdentityImagePicker } from '@/components/images/identity-picker';
interface AvatarPickerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Owning user's id. Drives palette + per-variant base seed. */
  userId: string;
  currentAvatarUrl: string | null;
  currentAvatarNsfw?: boolean | null;
  /**
   * Current `users.avatar_preferences.rasterise` value. Drives the
   * "Dithered / Original" toggle inside CropModal.
   */
  currentRasterise: boolean;
  /** Display name pre-fills the Search tab. Pass null/'' if unknown. */
  searchSeedQuery?: string;
  /** Stored Morfian seed from `users.avatarPreferences.morfianSeed`, if any. */
  morfianStoredSeed?: string;
  onAvatarChange: (url: string, avatarNsfw?: boolean | null) => void;
}

/**
 * Avatar picker — thin wrapper around `<IdentityImagePicker kind="avatar">`.
 * Tab order is Morfian (default) → Search → Upload (Pattern was retired
 * for avatars when Morfian shipped; hero still has it).
 */
export function AvatarPicker(props) {
  const $ = _c(14);
  let t0;
  if ($[0] !== props.currentAvatarNsfw) {
    t0 = props.currentAvatarNsfw !== undefined ? {
      currentAvatarNsfw: props.currentAvatarNsfw
    } : {};
    $[0] = props.currentAvatarNsfw;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = props.searchSeedQuery ?? "";
  let t2;
  if ($[2] !== props.morfianStoredSeed) {
    t2 = props.morfianStoredSeed !== undefined ? {
      morfianStoredSeed: props.morfianStoredSeed
    } : {};
    $[2] = props.morfianStoredSeed;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props.currentAvatarUrl || $[5] !== props.currentRasterise || $[6] !== props.onAvatarChange || $[7] !== props.onOpenChange || $[8] !== props.open || $[9] !== props.userId || $[10] !== t0 || $[11] !== t1 || $[12] !== t2) {
    t3 = <IdentityImagePicker kind="avatar" open={props.open} onOpenChange={props.onOpenChange} userId={props.userId} currentUrl={props.currentAvatarUrl} {...t0} currentRasterise={props.currentRasterise} searchSeedQuery={t1} {...t2} onChange={props.onAvatarChange} />;
    $[4] = props.currentAvatarUrl;
    $[5] = props.currentRasterise;
    $[6] = props.onAvatarChange;
    $[7] = props.onOpenChange;
    $[8] = props.open;
    $[9] = props.userId;
    $[10] = t0;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}